/**
 * mapControl.ts
 * Функции управления картой
 **/
import OLMap from "ol/Map";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {fromLonLat} from "ol/proj";
import {
  INITIAL_CENTER,
  INITIAL_ZOOM,
  DISTRICT_CENTER_OVERRIDES,
  DISTRICT_ZOOM_OVERRIDES,
  REGION_CENTER_OVERRIDES,
  REGION_ZOOM_OVERRIDES
} from "@/components/modules/MainMap/utils/mapConstants";

/**
 * Функция для приближения карты
 */
export const zoomIn = (map: OLMap | null) => {
    if (map) {
        const view = map.getView();
        const currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            view.animate({
                zoom: currentZoom + 1,
                duration: 250
            });
        }
    }
};

/**
 * Функция для отдаления карты
 */
export const zoomOut = (map: OLMap | null) => {
    if (map) {
        const view = map.getView();
        const currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            view.animate({
                zoom: currentZoom - 1,
                duration: 250
            });
        }
    }
};

/**
 * Функция для возврата к исходному виду карты
 */
export const animateToInitialView = (map: OLMap | null) => {
    if (map) {
        const view = map.getView();
        view.animate({
            center: INITIAL_CENTER,
            zoom: INITIAL_ZOOM,
            duration: 600
        });
    }
};

/**
 * Функция для плавного перехода к выбранному региону или округу
 */
export const animateToFeature = (
    map: OLMap | null,
    featureId: string,
    isDistrict: boolean,
    vectorLayerDistrict: VectorLayer<VectorSource> | null,
    vectorLayer: VectorLayer<VectorSource> | null
) => {
    if (!map) return;

    const view = map.getView();
    // Нормализуем ключ к lowercase для поиска в OVERRIDES
    const normalizedKey = featureId.toLowerCase();
    const overrideCoords = isDistrict
        ? DISTRICT_CENTER_OVERRIDES[normalizedKey]
        : REGION_CENTER_OVERRIDES[normalizedKey];

    const overrideZoom = isDistrict
        ? DISTRICT_ZOOM_OVERRIDES[normalizedKey]
        : REGION_ZOOM_OVERRIDES[normalizedKey];

    if (overrideCoords) {
        console.log("Зум и координаты", overrideCoords, overrideZoom, featureId);
        const center = fromLonLat(overrideCoords);
        view.animate({
            center: center,
            zoom: overrideZoom ? overrideZoom : 6,
            duration: 600
        });
    } else {
        const layer = isDistrict ? vectorLayerDistrict : vectorLayer;
        if (!layer) return;

        const source = layer.getSource();
        if (!source) return;

        const features = source.getFeatures();
        const feature = features.find(f => f.get("id") === featureId);

        if (!feature) return;

        const geometry = feature.getGeometry();
        if (!geometry) return;

        const extent = geometry.getExtent();

        view.fit(extent, {
            duration: 600,
            padding: [100, 100, 100, 100],
            maxZoom: isDistrict ? 5 : 7
        });
    }
};
